























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Spinner } from 'vue-image-spinner2';
import moment from 'moment-timezone';

@Component({
    name: 'logs',
    data: function () {
        return {
            logsPage_: 1,
        };
    },
    components: {
        Spinner,
    },
    computed: {
        ...mapState('logs', ['allLogs', 'allLogsLoading', 'logsPerPage', 'logsPage', 'logsTotal']),
        ...mapState('logs', {
            allLogs: (state: any) => {
                const allLogs = state.allLogs.map((log: any) => {
                    log.created_at = moment(log.created_at).format('DD/MM/YYYY hh:mm:ss');
                    return {
                        ...log,
                        tags: log.tags.replace(/ /g, '').split(','),
                    };
                });
                return allLogs;
            },
        }),
    },
})
export default class Logs extends Vue {
    public allLogs!: any;
    public allLogsLoading!: any;
    public logsPerPage!: any;
    public logsPage!: any;
    public logsPage_!: any;
    public log_word_search: any = '';
    public logsTotal!: any;
    allLogsHeaders = [
        { thClass: 'th', key: 'tags', label: 'Etiquetas' },
        { thClass: 'th', key: 'created_at', label: 'Fecha' },
        { thClass: 'th', key: 'message', label: 'Mensaje' },
        { thClass: 'th', key: 'type', label: 'Tipo' },
        { thClass: 'th', key: 'edit', label: '' },
    ];

    private selectedType = 'all';
    typeOptions: any = ['all', 'info', 'warning', 'danger'];

    clearFilters() {
        this.log_word_search = '';
        this.$router.push({
            path: 'logs',
            query: {},
        });
        this.logsPage_ = 1;
    }

    setUrlPage(page: any) {
        this.$router.push({
            path: 'logs',
            query: {
                ...this.$route.query,
                page,
            },
        });
        this.logsPage_ = page;
    }

    setUrlSearch(search: string) {
        search = search.trim();
        this.$router.push({
            path: 'logs',
            query: {
                ...this.$route.query,
                search,
            },
        });
    }

    @Watch('$route')
    getAllLogs() {
        const page = this.$route.query.page || 1;
        const search = this.$route.query.search || null;
        this.$store.dispatch('logs/getAll', {
            page,
            search,
        });
    }

    mounted() {
        this.getAllLogs();
        this.logsPage_ = 1;
    }
}
